export default `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <path fill="#7C7C7C" d="M87.233,52.282l-48.212,83.724c-6.026,10.332,1.507,23.461,13.56,23.461h96.638c12.054,0,19.587-12.914,13.561-23.461l-48.427-83.724C108.325,41.951,93.259,41.951,87.233,52.282z"/>
</svg>`